import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { verifyMagicLink } from "../lib/api";
import { useAuth } from "../lib/auth";
import { FullPageLoading } from "../components/Loading";
import { ArrowRightIcon, Eyebrow, HeadingItalic } from "../components/design";

export default function VerifyLink() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { signInWithToken } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) {
      setError("Es wurde kein Login-Token übergeben.");
      return;
    }
    (async () => {
      try {
        const { customToken } = await verifyMagicLink(token);
        await signInWithToken(customToken);
        navigate("/dashboard", { replace: true });
      } catch (e: any) {
        const code = e?.message || "verify_failed";
        const human =
          code === "token_expired"
            ? "Der Link ist abgelaufen. Bitte einen neuen anfordern."
            : code === "token_already_used"
              ? "Dieser Link wurde bereits verwendet. Bitte einen neuen anfordern."
              : code === "invalid_token" || code === "missing_token"
                ? "Der Link ist ungültig."
                : "Anmeldung fehlgeschlagen.";
        setError(human);
      }
    })();
  }, [token, signInWithToken, navigate]);

  if (!error) return <FullPageLoading label="Sie werden eingeloggt …" />;

  return (
    <div
      className="paper-bg"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 22,
        fontFamily: "var(--f-body)",
      }}
    >
      <div
        style={{
          maxWidth: 420,
          width: "100%",
          background: "var(--paper-50)",
          border: "1px solid rgba(43,26,15,0.10)",
          borderRadius: 14,
          padding: "28px 24px",
          boxShadow:
            "0 1px 0 rgba(43,26,15,0.04), 0 14px 24px -8px rgba(43,26,15,0.14)",
          textAlign: "center",
        }}
      >
        <Eyebrow style={{ marginBottom: 10 }}>Anmeldung</Eyebrow>
        <HeadingItalic size={26}>
          Anmeldung <em>nicht möglich</em>
        </HeadingItalic>
        <p
          style={{
            fontFamily: "var(--f-body)",
            fontSize: 15,
            lineHeight: 1.5,
            color: "var(--ink-soft)",
            margin: "0 0 20px",
          }}
        >
          {error}
        </p>
        <Link to="/login" className="btn-primary" style={{ width: "100%" }}>
          Neuen Link anfordern
          <ArrowRightIcon />
        </Link>
      </div>
    </div>
  );
}
